export const APPLICATION_CARD_WIDTH = '332px';
export const APPLICATION_CONTAINER_4_COLUMNS_WIDTH = '1440px';
export const APPLICATION_CONTAINER_3_COLUMNS_WIDTH = '1060px';
export const CARD_WIDTH = '282px';
export const PII_FIELD_MASKING_CLASS = 'fs-exclude'; // Full Story PII Mask CSS Class Name

export enum FUNNEL_LAYOUT_COLS {
  xs = 4,
  sm = 6,
  md = 8,
  lg = 10,
  xl = 12,
}
export enum LENDER_FEATURES_LAYOUT_COLS {
  xs = 1,
  sm = 2,
  md = 2,
  lg = 2,
  xl = 2,
}
export enum TEAMVIEW_EDIT_LAYOUT_COLS {
  xs = 4,
  sm = 6,
  md = 8,
  lg = 10,
  xl = 12,
}
export enum TEAMVIEW_APPLICATIONS_LAYOUT_COLS {
  xs = 4,
  sm = 8,
  md = 8,
  lg = 8,
  xl = 15,
}
export enum TEAMVIEW_SUMMARY_LAYOUT_COLS {
  xs = 4,
  sm = 6,
  md = 8,
  lg = 10,
  xl = 12,
}
export enum UNIT_GUTTER {
  xs = 'xxs',
  sm = 'xxs',
  md = 'xxs',
  lg = 'xxs',
  xl = 'sm',
}
export enum CUSTOMERVIEW_APPLICATIONS_LAYOUT_COLS {
  xs = 4,
  sm = 4,
  md = 8,
  lg = 8,
  xl = 9,
}
